module.exports = __webpack_public_path__ + "images/opening-act-841c65996436613dfed93bbecd1d2fc7.png";